import React, { FC, Fragment } from 'react';

import { FeedKey, Group } from 'api';
import { Layouts, Desktop, Mobile, EmptyState } from 'components';
import { useLocalStorage } from 'hooks';
import { Feed } from 'features/feed';
import { DEFAULT_SORT } from 'constants/index';

import { DesktopBanner, FeedMenu, MobileBanner } from './Group';

interface IProps {
  group: Group;
}

const GroupRemoved: FC<IProps> = props => {
  const { group } = props;
  const [sort, setSort] = useLocalStorage('timelineSort', DEFAULT_SORT);

  function handleSort() {
    setSort(!sort);
  }

  function renderMenu() {
    return <FeedMenu enableSort selectedGroup={group} onSort={handleSort} sort={sort} />;
  }

  function renderFeed() {
    const variables = {
      sort,
      key: FeedKey.Removedgroup,
      id: group.id,
    };

    return (
      <Feed
        emptyState={() => <EmptyState name="groupRemoved" />}
        variables={variables}
        selectedGroup={group}
      />
    );
  }

  function renderBanner() {
    const bannerProps = {
      group,
      menu: renderMenu(),
    };

    return (
      <Fragment>
        <Desktop>
          <DesktopBanner {...bannerProps} />
        </Desktop>
        <Mobile>
          <MobileBanner isFollowing {...bannerProps} />
        </Mobile>
      </Fragment>
    );
  }

  return (
    <Layouts.AppMain2Column
      desktopSplit="8/4"
      header={renderBanner()}
      left={renderFeed()}
      right={null}
    />
  );
};

export default GroupRemoved;
